import VueRouter from 'vue-router'
import Vue from 'global-vue'

import di from 'di';

import VueResource from 'vue-resource'
import * as VueGoogleMaps from 'vue2-google-maps'

export default class {

    run(){

        const config = di.get('config');

        /* ROUTER */
        Vue.use(VueRouter);


        /* RESOURCE */
        Vue.use(VueResource);
        Vue.http.options.root = config.apiUrl;

        Vue.use(VueGoogleMaps, {
            load: {
                key: 'AIzaSyDaO_wMvV6QNhYZtQRq3vD81nDMWYoDf1w',
                libraries: 'places'
            }
        });
    }
}